import React from 'react';
import ChartTitle from '../ChartTitle';
import {
  Section,
  Header,
  Controls,
  LabeledControl,
  ToggleGroup,
  ToggleOption,
  Selection,
  SubHeader,
  Slider,
  BackgroundColorControl,
} from '../../../reporting/sidebar/components';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';

function MainConfig() {
  const { get } = useReportConfiguration();

  return (
    <Section defaultOpen>
      <Header>Chart</Header>
      <ChartTitle />
      <SubHeader>Style</SubHeader>
      <Controls>
        <LabeledControl title='Bubble size' alignTop>
          <ToggleGroup configurationKey='pointSize'>
            <ToggleOption value='small'>
              <i className='fa-solid fa-circle' style={{ fontSize: 6 }} />
              Small
            </ToggleOption>
            <ToggleOption value='medium'>
              <i className='fa-solid fa-circle' style={{ fontSize: 8 }} />
              Medium
            </ToggleOption>
            <ToggleOption value='large'>
              <i className='fa-solid fa-circle' style={{ fontSize: 11 }} />
              Large
            </ToggleOption>
          </ToggleGroup>
        </LabeledControl>

        <BackgroundColorControl />

        <LabeledControl title='Labels'>
          <Selection
            configurationKey='showLabels'
            options={[
              ['On', true],
              ['Off', false],
              ['Highlights only', 'highlights'],
            ]}
          />
        </LabeledControl>

        <LabeledControl title='Highlight percentile'>
          <Slider
            props={{ min: 0, max: 100, labeled: 'below' }}
            configurationKey='percentile'
            disabled={get('showLabels') !== 'highlights'}
          />
        </LabeledControl>
      </Controls>
    </Section>
  );
}

export default MainConfig;
